import React, { useEffect, useRef } from 'react';
import MuiPopover, { PopoverActions, PopoverProps } from '@mui/material/Popover';

type Props = PopoverProps & {
  realignWhenContentChanged?: boolean;
};

export const Popover: React.FC<Props> = ({ realignWhenContentChanged, ...restProps }) => {
  const actionRef = useRef<PopoverActions>(null);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!realignWhenContentChanged || !restProps.open || !containerRef.current) return;
    const observer = new MutationObserver(() => {
      if (actionRef.current) actionRef.current.updatePosition();
    });

    observer.observe(containerRef.current, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    return () => {
      observer.disconnect();
    };
  }, [restProps.open, realignWhenContentChanged]);

  return (
    <MuiPopover action={actionRef} {...restProps}>
      <div ref={containerRef}>{restProps.children}</div>
    </MuiPopover>
  );
};
